/**
 * THE APP IS PORTRAIT ON A PHONE (§ F181, 2026-09-18).
 *
 * Jake: *"Also, the screen should not rotate…only in portrait."*
 *
 * § F96 made this true of the daily challenges (*"Wordle rotation is really
 * bad. Unplayable."*); the head-to-head Wordle is the same board outside that
 * shell and rotated freely. It is now ONE guard, mounted once in `App`, so a
 * new surface is covered by construction rather than by remembering.
 *
 * A web page cannot lock a phone's orientation: `screen.orientation.lock` only
 * works fullscreen and iOS Safari does not have it at all. It is still ASKED
 * for (Android honours it for an installed app), and what does the work
 * everywhere is this cover. WHERE it shows is pure CSS (`.gtw-rotate-guard`,
 * index.css): landscape AND a coarse pointer AND a short screen — a phone on
 * its side, never a desktop window and never an iPad.
 */

import { useEffect } from "react";
import { RotateCcw } from "lucide-react";

export function RotateGuard() {
  useEffect(() => {
    const orientation = screen.orientation as ScreenOrientation & {
      lock?: (o: string) => Promise<void>;
    };
    // Best effort, and silent: refusal is the normal answer in a browser tab.
    void orientation?.lock?.("portrait").catch(() => undefined);
  }, []);

  return (
    <div
      data-testid="app-rotate-guard"
      className="gtw-rotate-guard fixed inset-0 z-[70] bg-brand-primary items-center justify-center p-6"
      role="alert"
    >
      <div className="bg-white ink-border rounded-block-lg block-shadow-1 px-5 py-4 max-w-xs text-center flex flex-col items-center gap-2">
        <RotateCcw className="w-8 h-8" strokeWidth={2.5} aria-hidden="true" />
        <p className="font-heading font-extrabold uppercase tracking-tight text-lg leading-tight">
          Turn your phone upright
        </p>
        <p className="font-body text-sm text-black/70">The games play portrait.</p>
      </div>
    </div>
  );
}

export default RotateGuard;
